import {
  Collection, ItemView, locale, util
} from '@glu/core';
import dialog from '@glu/dialog';
import ManageDialogLayout from './manageDialogLayout';

import template from './multiColumnSortView.hbs';

export default ItemView.extend({
  template,

  ui: {
    switch: '.multi-column-sort-select',
    manageLink: '.multi-column-sort-manage a'
  },

  events: {
    'change @ui.switch': 'switchChange',
    'click .multi-column-sort-manage a:not(.disabled)': 'showManageDialog'
  },

  initialize() {
    this.label = this.options.label || locale.get('multiSortTitle');
    this.columnCollection = this.options.columnCollection;
    this.multiColumnSort = this.options.multiColumnSort;
    this.multiColumnSortStateColumns = this.options.multiColumnSortState[0] || [];
    this.multiColumnSortStateEnabled = this.options.multiColumnSortState[1] || false;

    this.listenTo(this, 'turnOff', () => this.toggleSwitch(false));
  },

  serializeData() {
    return {
      label: this.label,
      gridId: this.options.grid.cid
    };
  },

  onRender() {
    this.sortOnLoad();
  },

  sortOnLoad() {
    if (!this.multiColumnSortStateEnabled) {
      return;
    }
    this.ui.manageLink.removeClass('disabled');
    this.ui.switch.prop('checked', true);
    this.applyMultiColumnSort(this.getTargetCollection());
  },

  toggleSwitch(checked) {
    this.ui.switch.prop('checked', checked).trigger('change');
  },

  switchChange() {
    if (this.ui.switch.is(':checked')) {
      this.sortOn();
    } else {
      this.sortOff();
    }
  },

  sortOn() {
    this.ui.manageLink.removeClass('disabled');
    this.showManageDialog();
  },

  sortOff() {
    if (!this.ui.manageLink.hasClass('disabled')) {
      this.ui.manageLink.addClass('disabled');
      this.unApplyMultiColumnSort();
    }

    if (!util.isNullOrUndefined(this.manageDialogLayout)) {
      this.manageDialogLayout.close();
    }
  },

  getSortedColumnsCollection() {
    let columnCollectionJSON = this.columnCollection.toJSON();

    columnCollectionJSON = util.reduce(columnCollectionJSON, (result, column, i) => {
      if (
        !column.disableMultiSort &&
        column.condition !== false &&
        this.multiColumnSortStateColumns.indexOf(column.field) === -1
      ) {
        column.id = column.id || i;
        result.push(column);
      }
      return result;
    }, []);

    return new Collection(columnCollectionJSON);
  },
  getTargetCollection() {
    const columnCollectionJSON = this.columnCollection.toJSON();
    const targetCollectionJSON = [];

    if (!this.multiColumnSortStateColumns) {
      return new Collection();
    }

    util.each(this.multiColumnSortStateColumns, (stateColumn) => {
      util.each(columnCollectionJSON, (column, i) => {
        if (
          stateColumn === column.field &&
          !column.disableMultiSort &&
          column.condition !== false
        ) {
          column.id = column.id || i;
          targetCollectionJSON.push(column);
        }
      });
    });

    return new Collection(targetCollectionJSON);
  },
  showManageDialog(e) {
    const dialogTitle = `${locale.get('configure')} ${this.label}`;
    const manage = e ? this.$(e.currentTarget).parent().hasClass('multi-column-sort-manage') : false;

    this.manageDialogLayout = this.manageDialogLayout || new ManageDialogLayout({
      sortedColumnsCollection: this.getSortedColumnsCollection(),
      targetCollection: this.getTargetCollection(),
      listBuilderOptions: this.options.listBuilderOptions || {},
      dialogTitle,
      view: this
    });

    if (manage) {
      this.manageDialogLayout.setManage(manage);
    }

    dialog.open(this.manageDialogLayout);
  },

  applyMultiColumnSort(sortingCollection) {
    let tieBreakerModel;
    const applyMultiColumnSortCollection = sortingCollection.clone();

    if (this.options.listBuilderOptions && this.options.listBuilderOptions.tieBreaker) {
      const tieBreakerColumn = this.options.listBuilderOptions.tieBreaker;

      tieBreakerModel = this.columnCollection.where({
        field: tieBreakerColumn
      });

      const noTieBreaker = !applyMultiColumnSortCollection.where({
        field: tieBreakerColumn
      }).length;

      if (noTieBreaker) {
        applyMultiColumnSortCollection.add(tieBreakerModel);
      }
    }

    this.options.grid.applyMultiColumnSort(applyMultiColumnSortCollection);
    this.options.grid.changeCurrentPage(1);
  },

  unApplyMultiColumnSort() {
    this.options.grid.unApplyMultiColumnSort();
  }
});
